export default function organizationApiFetch(url, options = {}) {
    const configuredOrganizationId = process.env.REACT_APP_IQ_ORGANIZATION_ID;
    if (!configuredOrganizationId) {
        throw new Error("REACT_APP_IQ_ORGANIZATION_ID is not configured.");
    }

    const organizationId = Number(configuredOrganizationId);
    if (!/^\d+$/.test(configuredOrganizationId.trim()) ||
        !Number.isSafeInteger(organizationId) || organizationId <= 0) {
        throw new Error("REACT_APP_IQ_ORGANIZATION_ID must be a positive safe integer.");
    }

    const requestUrl = new URL(url);
    requestUrl.searchParams.set("organization_id", String(organizationId));

    const { body, ...requestOptions } = options;
    const method = (options.method || "GET").toUpperCase();
    const hasBody = method !== "GET" && method !== "HEAD";

    return fetch(requestUrl.toString(), {
        ...requestOptions,
        ...(hasBody ? {
            headers: {
                ...options.headers,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...body, organization_id: organizationId }),
        } : {}),
    });
}
